import React from 'react';
import { Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const MobileNotSupported: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md mx-auto text-center space-y-8">

        {/* Logo/Brand */}
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">Plot Studio</h1>
          <p className="text-sm text-muted-foreground">
            PLOT, WRITE, AND ORGANIZE IN ONE PLACE
          </p>
        </div>

        {/* Icon */}
        <div className="flex justify-center">
          <div className="p-4 rounded-lg bg-muted/50">
            <Monitor className="h-8 w-8 text-muted-foreground" />
          </div>
        </div>

        {/* Main Message */}
        <div className="space-y-4">
          <h2 className="text-lg font-medium">
            Best experienced on desktop
          </h2>

          <p className="text-muted-foreground leading-relaxed">
            Plot Studio is designed for desktop and laptop computers to provide
            the full creative writing experience with our rich interface and powerful features.
          </p>
        </div>

        {/* Call to Action */}
        <div className="space-y-4">
          <Button
            onClick={() => window.location.reload()}
            className="w-full"
          >
            I'm on Desktop Now
          </Button>

          <p className="text-xs text-muted-foreground">
            If you're on desktop, try refreshing or expanding your browser window
          </p>
        </div>

      </div>
    </div>
  );
};
